/* eslint-disable import/no-unresolved */
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  AudioElement,
  CommonButton,
  ImageElement,
  RippleEffect,
  VideoElement,
} from "components/UiElement";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import ModalComponent from "components/UiElement/Modal/Index";
import { checkValidData, encoder, setSessionStorage } from "utils";
import {
  WordFormatter,
  addNameWithCommaFormatter,
  middleNameFormatter,
  strings,
  textFormatter,
} from "components/Formatter";
import Comment from "pages/User/Comment";
import { useSelector } from "react-redux";
import { selectUserData } from "redux/AuthSlice/index.slice";
import routesMap from "routeControl/userRouteMap";
import { ext } from "helpers";

function TestimonialComponent({
  commentList,
  getMemorialCommentList,
  commentModal,
  handleCloseModalComment,
  setCommentModel,
  memorialData,
  t,
}) {
  const userData = useSelector(selectUserData);
  const userId = userData?.id;
  const role = userData?.userRole?.role?.role;
  const { id } = useParams();
  const navigate = useNavigate();
  const onLogin = async () => {
    let path = `/${"theme04"}/${id}?${encoder("theme04")}`;
    setSessionStorage("path", path);
    setSessionStorage("theme", "theme04");
    navigate(routesMap.LOGIN.path);
  };
  return (
    <>
      <section className="testimonialsSec bg-700 py-80" id="story">
        <Container>
          <div className="commonHead commonHead-light">
            <Row className="align-items-end">
              <Col md={6} className="mb-md-0 mb-3 text-sm-start text-center">
                <div className="commonHead_sub">
                  {t("text.theme.heartFelt")}
                </div>
                <h2 className="commonHead_title mb-0 text-break">
                  {t("text.theme.memoriesOf")}{" "}
                  {checkValidData(
                    textFormatter(
                      middleNameFormatter(
                        memorialData?.firstName,
                        memorialData?.middleName,
                        memorialData?.lastName,
                        true
                      )
                    )
                  )}
                </h2>
              </Col>
              <Col md={6} className="text-sm-end text-start text-center">
                {" "}
                <div className="d-flex justify-content-sm-end justify-content-center btnFlex">
                  {role === "user" ? (
                    <div className="d-flex justify-content-center btnFlex">
                      {userId === memorialData?.userId && (
                        <RippleEffect>
                          <Link
                            to={`${routesMap.PENDINGCOMMENTS.path}/${id}`}
                            className="mt-0 rounded btn btn-outline-white"
                          >
                            {t("text.theme.pendingComments")}
                          </Link>
                        </RippleEffect>
                      )}

                      <RippleEffect extraClassName="justify-content-end">
                        <CommonButton
                          variant="danger"
                          size="lg"
                          className="rounded mt-0 ms-sm-auto px-xxl-4"
                          onClick={() => setCommentModel(true)}
                        >
                          {t("text.theme.shareStory")}
                        </CommonButton>
                      </RippleEffect>
                    </div>
                  ) : (
                    <RippleEffect>
                      <CommonButton
                        variant="danger"
                        extraClassName="mt-md-4 mt-2"
                        onClick={() => onLogin()}
                      >
                        Share A Story
                      </CommonButton>
                    </RippleEffect>
                  )}
                </div>
              </Col>
            </Row>
          </div>
          {/* Slider  */}
          <Swiper
            navigation
            modules={[Navigation]}
            spaceBetween={20}
            className="testimonialSlider"
          >
            {commentList?.length > 0 &&
              commentList.map((data, index) => {
                if (data?.status === "accept")
                  return (
                    <SwiperSlide className="sliderLeft" key={index}>
                      <Row>
                        <Col md={7}>
                          <div>
                            <p className="sliderLeft_cnt text-break">
                              {data?.comment}
                            </p>
                          </div>
                        </Col>
                        <Col md={5} className="mb-md-0 mb-3 ps-xl-5">
                          {data?.filePathUrl && (
                            <>
                              {data?.filePathUrl?.split(".")?.pop() === "pdf" ||
                              data?.filePathUrl?.split(".")?.pop() === "PDF" ||
                              data?.filePathUrl?.split(".")?.pop() ===
                                "docx" ? (
                                <>
                                  <div className="d-flex align-items-center justify-content-center flex-column slider_imgbox slider_imgbox-pdf">
                                    <img
                                      src="/assets/images/frontend/theme02/pdf-white.webp"
                                      crossOrigin="anonymous"
                                      alt="pdf-white-img"
                                      className="smallPic"
                                    />
                                    <Link
                                      to={data?.filePathUrl || "#"}
                                      target="blank"
                                      className="viewBtn"
                                    >
                                      View PDF
                                    </Link>
                                  </div>
                                </>
                              ) : null}
                              {ext?.[data?.filePathUrl?.split(".")?.pop()] ===
                                "image" && (
                                <ImageElement
                                  className="img-fluid sliderLeft_img img-fluid"
                                  previewSource={data?.filePathUrl}
                                />
                              )}

                              {ext?.[data?.filePathUrl?.split(".")?.pop()] ===
                                "audio" && (
                                <AudioElement
                                  classname="d-block m-auto"
                                  previewSource={data?.filePathUrl}
                                  alt="timeline-img"
                                />
                              )}
                              {ext?.[data?.filePathUrl?.split(".")?.pop()] ===
                                "video" && (
                                <>
                                  {/* <Link to="#" className="landmakrPlay">
                                      <em className="icon-video" />
                                    </Link> */}
                                  <VideoElement
                                    previewSource={data?.filePathUrl}
                                    extraClassName="w-100 h-100 object-fit-cover"
                                    alt="timeline-img"
                                    controls
                                    autoPlay={false}
                                  />
                                </>
                              )}
                            </>
                          )}
                        </Col>
                      </Row>
                      <div className="sliderLeft_profile d-flex align-items-center">
                        {data?.user?.profileImageUrl?.substring(
                          data?.user?.profileImageUrl?.lastIndexOf("/") + 1
                        ) === "userDefault.png" ? (
                          <div className="userDefault">
                            <ImageElement
                              className="img-fluid rounded-circle"
                              previewSource={data?.user?.profileImageUrl}
                            />
                          </div>
                        ) : (
                          <ImageElement
                            className="img-fluid rounded-circle"
                            previewSource={data?.user?.profileImageUrl}
                          />
                        )}
                        <div className="ms-md-3 ms-2">
                          <p className="text-truncate mb-0">
                            {checkValidData(
                              textFormatter(
                                middleNameFormatter(
                                  data?.user?.firstName,
                                  data?.user?.middleName,
                                  data?.user?.lastName,
                                  true
                                )
                              )
                            )}
                          </p>
                          <span className="text-truncate  d-flex align-items-center">
                            <em className="icon-location me-md-2 me-1" />{" "}
                            {addNameWithCommaFormatter(
                              WordFormatter(data?.user?.state?.name),
                              strings(data?.user?.country?.name)
                            )}
                          </span>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
              })}
          </Swiper>
        </Container>
      </section>
      <ModalComponent
        show={commentModal}
        size="md"
        title="Write Comment"
        closeButton="true"
        modalExtraClass="commentModel"
        extraTitleClassName="commentModel_title"
        onHandleCancel={handleCloseModalComment}
      >
        <Comment
          handleCloseModalComment={() => {
            handleCloseModalComment();
            getMemorialCommentList();
          }}
          oneSubscriptionData={memorialData?.userSubscription}
          getMemorialCommentList={getMemorialCommentList}
          theme="theme04"
        />
      </ModalComponent>
    </>
  );
}

export default TestimonialComponent;
